import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { ExternalCourseEnrolled } from '../../models/externalCoursesEnrolled.model'
import {
  ExternalCoursesEnrolledListParams,
  ExternalCoursesEnrolledListSort,
  GetListResponse,
} from 'api/externalCoursesEnrolled/List'

export const EXTERNAL_COURSE_ENROLLED_GET_LIST =
  'EXTERNAL_COURSE_ENROLLED_GET_LIST'
export const EXTERNAL_COURSE_ENROLLED_GET_LIST_SUCCESS =
  'EXTERNAL_COURSE_ENROLLED_GET_LIST_SUCCESS'
export const EXTERNAL_COURSE_ENROLLED_LOADING =
  'EXTERNAL_COURSE_ENROLLED_LOADING'

export interface ExternalCoursesEnrolledListPayload {
  params: ExternalCoursesEnrolledListParams
  callback?(resList: GetListResponse): void
}

export const Actions = {
  getList: (data: ExternalCoursesEnrolledListPayload) =>
    createAction(EXTERNAL_COURSE_ENROLLED_GET_LIST, data),
  setListSuccess: (
    data: ExternalCourseEnrolled[],
    total: number,
    perPage: number,
    sort?: ExternalCoursesEnrolledListSort
  ) =>
    createAction(EXTERNAL_COURSE_ENROLLED_GET_LIST_SUCCESS, {
      data,
      total,
      perPage,
      sort,
    }),
  setLoading: (loading: boolean) =>
    createAction(EXTERNAL_COURSE_ENROLLED_LOADING, { loading }),
}

export type Actions = ActionsUnion<typeof Actions>
